// SLT last-click storage v1.1
// Persists 30 days; overwrites PJ attribution when any utm_source is present.
(function () {
  const qs = new URLSearchParams(window.location.search);
  const get = (k) => {
    const v = qs.get(k);
    return v && v.trim() ? v.trim() : null;
  };

  const srccode = get("srccode");
  const source = (get("source") || "").toLowerCase();

  const publisherId =
    get("publisherId") || get("publisherID") || get("publisherid");
  const clickId = get("clickId") || get("clickID") || get("clickid");

  const utm_source = get("utm_source");
  const utm_medium = get("utm_medium");
  const utm_campaign = get("utm_campaign");

  const gclid = get("gclid");
  const fbclid = get("fbclid");
  const msclkid = get("msclkid");

  // numeric > 0 requirement for publisherId/clickId

  const publisherNum = publisherId ? Number(publisherId) : NaN;
  const clickNum = clickId ? Number(clickId) : NaN;
  const hasPublisherNum = Number.isFinite(publisherNum) && publisherNum > 0;
  const hasClickNum = Number.isFinite(clickNum) && clickNum > 0;

  // Your Pepperjam trigger definition:
  const isPepperjamTouch =
    srccode === "PJSLT" ||
    (typeof srccode === "string" && srccode.indexOf("PJ") === 0) ||
    source === "pepperjam" ||
    hasPublisherNum ||
    hasClickNum;

  // Your overwrite definition: "any UTM set"
  const isUtmTouch = Boolean(utm_source) && utm_source != "affiliate";

  function normalizeUtmSource(src) {
    const s = String(src || "").toLowerCase();
    if (gclid || s === "google") return "google";
    if (fbclid || s === "facebook" || s === "meta") return "facebook";
    if (msclkid || s === "bing") return "bing";
    if (s === "duckduckgo" || s === "ddg") return "duckduckgo";
    if (s === "attentive" || s === "sms") return "attentive";
    if (s === "affiliate" || s === "pepperjam") return "pepperjam";
    return s || "unknown";
  }

  let payload = null;
  if (isUtmTouch) {
    payload = {
      ts: Date.now(),
      source: normalizeUtmSource(utm_source),
      utm_source,
      utm_medium,
      utm_campaign,
      gclid,
      fbclid,
      msclkid,
      publisher_id: null,
      affiliate_click_id: null,
      srccode: null,
    };
  } else if (isPepperjamTouch) {
    payload = {
      ts: Date.now(),
      source: "pepperjam",
      utm_source,
      utm_medium,
      utm_campaign,
      publisher_id: hasPublisherNum ? String(publisherId) : null,
      affiliate_click_id: hasClickNum ? String(clickId) : null,
      srccode: srccode || null,
    };
  } else if (gclid || fbclid || msclkid) {
    payload = {
      ts: Date.now(),
      source: gclid ? "google" : fbclid ? "facebook" : "bing",
      utm_source,
      utm_medium,
      utm_campaign,
      gclid,
      fbclid,
      msclkid,
      publisher_id: null,
      affiliate_click_id: null,
      srccode: null,
    };
  } else {
    return; // no eligible touch
  }

  // Persist full snapshot to localStorage
  try {
    localStorage.setItem("slt_last_click", JSON.stringify(payload));
  } catch {}

  // Cookie fallback (covers checkout host differences)
  const host = location.hostname.replace(/^www\./i, "");
  const cookieDomain = `; Domain=.${host}`;

  try {
    const compact = {
      ts: payload.ts,
      source: payload.source,
      utm_medium: payload.utm_medium,
      has_click_id: payload.gclid || payload.fbclid || payload.msclkid ? 1 : 0,
      publisher_id: payload.publisher_id,
      affiliate_click_id: payload.affiliate_click_id,
    };

    document.cookie =
      "_slt_last_click=" +
      encodeURIComponent(JSON.stringify(compact)) +
      "; Max-Age=" +
      String(60 * 60 * 24 * 30) +
      "; Path=/" +
      cookieDomain +
      "; SameSite=Lax";
  } catch {}
})();
